module.exports = __webpack_public_path__ + "media/images/logo_640_B-8d0ce6acfb2e30b8b28f7bf3429a080f.jpg";